export default {"src":"/_next/static/media/delivery-truck.060505b5.svg","height":71,"width":69,"blurWidth":0,"blurHeight":0};